export const ThemeStylesModelModule = angular
    .module('app.services.model.models.themeStyles', [])
    .value('themeStyles', {
        selectedColorScheme: 'Number',
        selectedFontScheme: 'Number',
        colorSchemes: 'Array',
        fontSchemes: 'Array',
        editables: 'Array',
        aceModel: 'String'
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/data/model/models/themeStyles.model.js